import * as yup from "yup";

export const Validations = yup.object({
    name: yup.string().required("space name is a required field"),
    userMobileNo: yup.string().required("mobile no is a required field").nullable(),
    deviceMacIds: yup.array().required("devices is a required field").nullable(),
    countryPrefix: yup.string().required("country code is a required field")
});
